import './collapser.less';
import template from './kp-collapser.tpl.ftl';

/**
 * @ngdoc component
 * @name kpCollapser
 * @module portaro.components
 *
 * @param {number=} height Height of collapser
 *
 * @description
 * Component for show-more/show-less functionality
 *
 * @example
 * ```html
 *  <kp-collapser>
 *      <p>
 *          Some looooong text
 *      </p>
 *  </kp-collapser>
 * ```
 */
export class CollapserComponentController {

    public height: string;
    public collapsed: boolean;

    /*@ngInject*/
    constructor() {
        this.collapsed = true;
    }

    toggle() {
        this.collapsed = !this.collapsed;
    }
}

export default class CollapserComponent {
    public static componentName = 'kpCollapser';

    public templateUrl = template;

    public transclude = true;

    public bindings = {
        height: '@'
    };

    public controller = CollapserComponentController;
}